//import Moment from "moment";

const getCount = (state) => {
	return state.mapasCotacao.length;
}

const ultimaAtualizacaoListaMapa = (state) => {
	if (state.ultimaAtualizacaoListaMapa == null) {
		return true;
	}
	else if(!state.mapasCotacao)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.mapasCotacao.length == 0 ||
			hour - state.ultimaAtualizacaoListaMapa.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaMapa
}